<template>

  <div id="app">
    <el-header  v-if="$route.path !== '/login' && showMenu" style="height: 90px">
        <div class="mod-card1" id="JMod-card1">
          <div class="mod-list">
            <div class="mod-item logo" id="JShowH5MenuList">
              <img src="./assets/3DPPT_LOGO_WHITE.png" alt="" class="logoPc">
              <img src="./assets/3DPPT_LOGO_normal.png" alt="" class="logoPc1">
              <span class="logoh5">
                <i class="fa fa-navicon"> </i>
                <h2>3DPPT</h2>
              </span>
              <!-- <img src="./static/image/h5logo.png" alt="" > -->
            </div>
            <div class="mod-item">
              <div class="mod-link h5logo">
                  <img src="./assets/3dh5logo.png" alt="">
                </div>
              <div class="mod-link">
              <a href="//3dpptx.com"> 首页</a></div>
              <div class="mod-link">
              <a href="//3dpptx.com/rights"> 会员权益</a></div>
              <div class="mod-link">
              <a href="javascript:void(0)"> 使用教程</a></div>
              <div class="mod-link active JshowQrcode JContactUs" >
              <a href="//3dpptx.com/designers"> 联系设计师</a>
              <!-- <span class="qrcode-box"><img src="./assets/wx.png" alt=""></span> -->
              </div>
              <div class="mod-link active JshowQrcode JContactUs">
              <a href="//3dpptx.com/join-us"> 设计师入驻</a>
              <!-- <span class="qrcode-box"><img src="./assets/wx.png" alt=""></span> -->
              </div>

            </div>
            <div class="mod-item login-part">
              <div class="login-item1" id="JuseCenter1" v-if="showLogin">
                <div class="mod-link" ><a href="/ptm-client/#/login">登录</a></div>
                <div class="mod-link" ><a href="/ptm-client/#/login?type=1">注册</a></div>
              </div>
              <div class="login-item2" id="JuseCenter" v-if="!showLogin">
                <div class="mod11-box" >
                  <div class="mod-spe-list" >
                    <img :src="userInfo.avatar" alt="">
                    <div class="mod-spe-item">
                      <div class="mod-spe-link"><a href="/ptm-client/#/user-infor">个人中心</a></div>
                      <div class="mod-spe-link" @click="loginOutCb">退出登录</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </el-header>
      <div v-if="$route.path !== '/login' && showMenu" class="li-user-header">
          <user-header></user-header>
      </div>
    <el-container class="diy-container" :class="{'container-fix':showMenu}"  v-if="$route.path !== '/login'">
      <el-aside width="200px;" v-if="showMenu && $route.path.indexOf('/update-info') === -1">
        <menu-main :designerVisible="designerVisible" :applyVisible="applyVisible"></menu-main>
      </el-aside>
      <el-main class="diy-el-main" :class="{'fix-main-box': showMenu}" id="JMainBox">
        <div class="main-warpper">
          <router-view/>
        </div>
      </el-main>
    </el-container>
    <login-part v-if="$route.path === '/login'"></login-part>

  </div>

</template>

<script>
import {loginOut, getUserInfo} from '../src/api/index'
import MenuMain from './components/layout/menu.vue'
import HeaderContent from './components/layout/header'
import loginPart from './components/business/login-part.vue'
import {mapActions, mapState, mapMutations} from 'vuex'
export default {
    components: {
        HeaderContent,
        loginPart,
        MenuMain,
        'user-header': () => import('./views/userInfor/header.vue')
    },
    data () {
        return {
            loading: null,
            hybirdPath: [
                '/create-order',
                '/pay-list',
                '/order',
                '/3d-share',
                '/login'
            ],
            designerVisible: false,
            applyVisible: false,
            noLeftMenu: ['/update-info/1', '/update-info/2'],
            // userInfo: {},
            showLogin: false,
            showMenu: false
        }
    },
    watch: {
        $route (to) {
            if (this.hybirdPath.indexOf(to.path) !== -1) {
                this.showMenu = false
            } else {
                this.showMenu = true
            }
            this.loading.close()
            // 非内嵌客户端及首页展示用户信息
            // 设计师入驻上传页面无需请求用户信息
            if (this.showMenu) {
                getUserInfo().then(res => {
                    if (res) {
                        this.designerVisible = res.designer
                        this.applyVisible = res.applyVisible
                        this.setUserInfo(res)
                    }
                })
            }
        }
    },
    computed: {
        ...mapState({
            userInfo: (state) => state.user.userInfo
            // taskList: (state) => state.task.taskList,
            // toRouter: (state) => state.router.mainMenuIndexes
        })
    },
    created () {
        this.loading = this.$loading()
    },
    mounted () {
        // 非登录页及内嵌页请求图片上传地址
    },
    methods: {
        loginOutCb () {
            loginOut().then(res => {
                if (res) {
                    localStorage.removeItem('HD_PTM_USERINFO')
                    setTimeout(function () {
                        location.href = '/'
                    }, 200)
                }
            })
        },
        loginPartHanlder () {
            // 登录控件逻辑
            if (localStorage.getItem('HD_PTM_USERINFO') &&
            localStorage.getItem('HD_PTM_USERINFO') !== 'null' &&
            localStorage.getItem('HD_PTM_USERINFO') !== 'undefined') {
                this.showLogin = true
            } else {
                this.showLogin = false
            }
        },
        ...mapActions({
            loadUrlsAction: 'uploadUrls/changeUrlsAction'
            // loadTaskList: 'task/changeTaskAction',
            // loadResourceTypes: 'resource/getResourceTypes'
        }),
        ...mapMutations({
            setUserInfo: 'user/setUserInfo'
        })

    }
}
</script>

<style lang="scss">
html,body{
  height: 100%;
  background: #fff;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
}
body{
  min-width: 1560px;
}

.main-warpper{
  box-sizing: border-box;
  // padding: 0 50px 0 50px;

  margin:0 auto;
}
.diy-el-main{
  overflow: inherit;
  padding-right: 0;
  padding-left: 0;
}
.el-aside{
  width: 288px;
  // height:100%;
  background: #fff;
  box-shadow: 0 0 8px 0 rgba(232,237,250, .6);
  margin-left: 110px;
  margin-top:20px;
  border-radius: 6px;
}
.diy-container{
    height: calc(100% - 250px);
    overflow: auto;

  .el-menu{
    border-right: none;
  }
  .el-header{
    padding:0;
  }
}

.screen-box {
  overflow: hidden;
  height: 40px;
  line-height: 40px;
  .el-form-item{
    margin-bottom: 0
  }
}
.table-box{
  margin-top: 27px;
}

.order-warpper{

  font-size: 14px;
  overflow-x: hidden;
  color: #4a4a4a !important;
  .el-form-item__label{
    color: #4a4a4a !important;
  }
  .cell{
    font-weight: normal;
    color: #4a4a4a !important;
    padding-left: 53px !important;
  }
  .el-table td, .el-table th.is-leaf{
    border-bottom:1px solid #eeeeee;
  }
  .text-hidden-oneline{
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
    white-space: nowrap;
  }
  .text-hidden-twoline{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    overflow: hidden;
  }

}
.table-box .el-table__empty-text{
.el-empty__image{
  margin:20px  auto
}

}
.main-warpper{
  // height: 100%;
}
.img-vmiddle {
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  align-items: center;
}
.table-box  .el-table__header-wrapper .cell{
    font-weight: bold;
}
.el-main{
  padding:  0;
}
.in-pay-warpper,.order-warpper{
  padding-top:60px
}
.order-warpper{
  padding-bottom: 50px;
}

//  .edit-warpper{

//     .el-input--suffix .el-input__inner{
//       width: 90% !important;
//     }
//   }

.new-user-box .el-table__header-wrapper{
  border-radius: 10px 10px 0 0;
}

.new-user-box .el-table td, .new-user-box .el-table th.is-leaf{
  border: none;
}
.new-user-box{
 .row-bg1{
        color: #fde7cf;
        background: rgba($color: #000000, $alpha: 0.4);
    }
    .row-bg2{
      color: #fde7cf;
        background: rgba($color: #000000, $alpha: 0.8);
    }
    .el-table--enable-row-hover .el-table__body tr:hover>td{
      background: none;
    }
    // .el-table th, .el-table tr{
    //   background-color: inherit;
    // }
    ::-webkit-scrollbar-thumb{
      background: #87522d;
      border-radius: 20px;
    }
    ::-webkit-scrollbar{
      background: #0e0c0c;
    }
  }
.spe-btn-box .el-button--primary {
  width: 140px;
  background:url('../static/image/icon_button.svg') no-repeat;
}
.mod5-list  .el-button--primary{
  width: 100%;
}
.pr110 {
  padding-right: 110px;
}
.fix-main-box{
  overflow: hidden;
  margin: 20px 110px 0 20px;
  .main-warpper{
    height: 100%;
  }
}
.container-fix{
  background: #f4f5f6;
  // .fix-main-box{
  //   background: #fff;
  // }
}
.mod2-box .el-form--label-top .el-form-item__label{
  font-size: 14px;
  color: #4a4a4a;
  padding-bottom:0
}
.mod2-box .el-textarea__inner{
  height: 216px;
}

.user-infor-box .el-dialog__body{
  padding: 0;
}
.user-infor-box .el-dialog__footer{
  padding: 10px 30px 30px 30px;

}
.user-infor-box .el-input--small{
  width: 50%;
  margin-right: 10px;
}
.mod5-list{
    display: flex;
    justify-content: space-between;
    .v-code-img {
        display: inline-block;
        width:100px;
        overflow: hidden;
        vertical-align: middle;
        border-radius: 6px;
    }
    .mod-item:first-child{
    //    padding-right:10px;
    width: 160px;
    }
    .mod-item:last-child{
    //    padding-left: 10px;
        width: 140px;
    }
    .el-icon-refresh-right{
        font-size: 20px;
        color: #00a4e0;
        cursor: pointer;
        display: inline-block;
    vertical-align: middle;
    margin-left: 8px;
    }
}

.form-item-fix1 .el-form-item__content{
  margin-left: 0 !important;
  color: #9b9b9b;
}
.fix-dialog-footer .el-dialog__footer{
  padding: 10px 40px 30px 42px;
}
.check-in-box .el-form-item__label{
  color: #333;
}
.agree-link {
  color: #00a4e0;
}

// webuploader

.upload-btn-warpper{
  position: relative;
}

.upload-btn-tip{
    display: block;
    width: 226px;
    font-size: 12px;
    color: #ccc;
    margin-top: 5px;
    /* height: 30px; */
    line-height: 19px;
  }
  .upload-btn {
    border: 1px dashed #e8e8e8;
    height: 90px;
    width: 90px;
    text-align: center;
    color: #939aa3;
    cursor: pointer;
    z-index: 600;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 20px;
    background-color: #fafafa;
}
.li-user-header {
    height: 160px;
    background: url('./assets/designer/user_bg.png') center no-repeat;
    margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue